export default "__VITE_ASSET__BOnMXmr1__"